import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import OTActionMenu from "./OTActionMenu";
const AddUpdateOT = ({ selectedOT, onClose, refreshOTList }) => {
  const isEdit = !!(selectedOT && selectedOT.ot_id);

  const [formData, setFormData] = useState({
    ot_id: null,
    ot_code: "",
    ot_name: "",
    state_id: "",
    based_on: "Basic",
    pay_type: "Single",
    ot_rate: "",
    ot_multiplier: 1.0,
    min_ot_hours_day: 0,
    max_ot_hours_day: 2,
    min_ot_hours_month: 0,
    max_ot_hours_month: 50,
    rounding_rule: "15M",
    approval_required: true,
    carry_forward_allowed: false,
    is_active: true,
    company_id: 13,
    plant_id: 1,
    country_id: 8,
  });

  const [stateList, setStateList] = useState([]);
useEffect(() => {
  if (selectedOT) {
    setFormData({
      ot_id: selectedOT.ot_id || null,
      ot_code: selectedOT.ot_code || "",
      ot_name: selectedOT.ot_name || "",
      state_id: selectedOT.state_id || "",
      based_on: selectedOT.based_on || "Basic",
      pay_type: selectedOT.pay_type || "Single",
      ot_rate: selectedOT.ot_rate || "",
      ot_multiplier: selectedOT.ot_multiplier ?? 1.0,
      min_ot_hours_day: selectedOT.min_ot_hours_day ?? 0,
      max_ot_hours_day: selectedOT.max_ot_hours_day ?? 2,
      min_ot_hours_month: selectedOT.min_ot_hours_month ?? 0,
      max_ot_hours_month: selectedOT.max_ot_hours_month ?? 50,
      rounding_rule: selectedOT.rounding_rule || "15M",
      approval_required: selectedOT.approval_required ?? true,
      carry_forward_allowed: selectedOT.carry_forward_allowed ?? false,
      is_active: selectedOT.is_active ?? true,
      company_id: selectedOT.company_id || 13,
      plant_id: selectedOT.plant_id || 1,
      country_id: selectedOT.country_id || 8,
    });
  } else {
    resetForm();
  }
}, [selectedOT]);

  useEffect(() => {
    if (selectedOT) {
      setFormData({ ...selectedOT });
    } else {
      resetForm();
    }
    fetchStateList();
  }, [selectedOT]);

  const resetForm = () => {
    setFormData({
      ot_id: null,
      ot_code: "",
      ot_name: "",
      state_id: "",
      based_on: "Basic",
      pay_type: "Single",
      ot_rate: "",
      ot_multiplier: 1.0,
      min_ot_hours_day: 0,
      max_ot_hours_day: 2,
      min_ot_hours_month: 0,
      max_ot_hours_month: 50,
      rounding_rule: "15M",
      approval_required: true,
      carry_forward_allowed: false,
      is_active: true,
      company_id: 13,
      plant_id: 1,
      country_id: 8,
    });
  };

  const fetchStateList = async () => {
    try {
      const payload = { p_companyid: 13, p_plant_id: 1, p_countryid: 8 };
      const res = await callApi(API_ENDPOINTS.Location_GET_STATE, "POST", { "Content-Type": "application/json" }, payload);
      if (res) setStateList(res);
    } catch (err) {
      console.error("Error fetching states:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSave = async () => {
    try {
      const res = await callApi(API_ENDPOINTS.OT_MASTER_ADDUPDATE, "POST", { "Content-Type": "application/json" }, formData);
      if (res?.success) {
        alert("✅ OT saved successfully");
        refreshOTList();
        onClose();
      } else {
        alert("❌ Failed to save OT");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Error while saving OT");
    }
  };

  const handleDelete = async () => {
    if (!formData.ot_id) return alert("Select an OT to delete");
    try {
      const res = await callApi(API_ENDPOINTS.OT_MASTER_DELETE, "POST", { "Content-Type": "application/json" }, { ot_id: formData.ot_id });
      if (res?.success) {
        alert("✅ OT deleted successfully");
        refreshOTList();
        onClose();
      } else {
        alert("❌ Failed to delete OT");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Error while deleting OT");
    }
  };

  return (
    <Grid container spacing={2}>
        <OTActionMenu
  title={isEdit ? "Edit Overtime Rule" : "Add New Overtime Rule"}
  showSave
  showDelete
  showExit
  isEdit={isEdit}
  onSave={handleSave}
  onDelete={handleDelete}
  onExit={onClose}
  saveDisabled={!formData.ot_code || !formData.ot_name}
/>

      {/* <Grid item xs={12}>
        <Typography variant="h6">{isEdit ? "Edit OT Master" : "New OT Master"}</Typography>
      </Grid> */}

      {/* Row 1 */}
      <Grid item xs={6}>
        <TextField label="OT Code" name="ot_code" value={formData.ot_code} onChange={handleChange} fullWidth />
      </Grid>
      <Grid item xs={6}>
        <TextField label="OT Name" name="ot_name" value={formData.ot_name} onChange={handleChange} fullWidth />
      </Grid>

      {/* Row 2 */}
      <Grid item xs={6}>
        <FormControl fullWidth>
          <InputLabel>State</InputLabel>
          <Select name="state_id" value={formData.state_id} onChange={handleChange}>
            {stateList.map((s, idx) => (
              <MenuItem key={idx} value={s.id || s.state_id}>{s.description || s.state_name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <TextField select fullWidth label="Based On" name="based_on" value={formData.based_on} onChange={handleChange}>
          <MenuItem value="Basic">Basic</MenuItem>
          <MenuItem value="Gross">Gross</MenuItem>
          <MenuItem value="Hourly">Hourly</MenuItem>
          <MenuItem value="Fixed">Fixed</MenuItem>
        </TextField>
      </Grid>

      {/* Row 3 */}
      <Grid item xs={6}>
        <TextField select fullWidth label="Pay Type" name="pay_type" value={formData.pay_type} onChange={handleChange}>
          <MenuItem value="Single">Single (1x)</MenuItem>
          <MenuItem value="Double">Double (2x)</MenuItem>
          <MenuItem value="Triple">Triple (3x)</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={6}>
        <TextField label="OT Rate" name="ot_rate" type="number" value={formData.ot_rate} onChange={handleChange} fullWidth />
      </Grid>

      {/* Row 4 */}
      <Grid item xs={6}>
        <TextField label="OT Multiplier" name="ot_multiplier" type="number" value={formData.ot_multiplier} onChange={handleChange} fullWidth />
      </Grid>
      <Grid item xs={6}>
        <TextField label="Min OT Hours (Day)" name="min_ot_hours_day" type="number" value={formData.min_ot_hours_day} onChange={handleChange} fullWidth />
      </Grid>

      {/* Row 5 */}
      <Grid item xs={6}>
        <TextField label="Max OT Hours (Day)" name="max_ot_hours_day" type="number" value={formData.max_ot_hours_day} onChange={handleChange} fullWidth />
      </Grid>
      <Grid item xs={6}>
        <TextField label="Min OT Hours (Month)" name="min_ot_hours_month" type="number" value={formData.min_ot_hours_month} onChange={handleChange} fullWidth />
      </Grid>

      {/* Row 6 */}
      <Grid item xs={6}>
        <TextField label="Max OT Hours (Month)" name="max_ot_hours_month" type="number" value={formData.max_ot_hours_month} onChange={handleChange} fullWidth />
      </Grid>
      <Grid item xs={6}>
        <TextField select fullWidth label="Rounding Rule" name="rounding_rule" value={formData.rounding_rule} onChange={handleChange}>
          <MenuItem value="15M">15 Minutes</MenuItem>
          <MenuItem value="30M">30 Minutes</MenuItem>
          <MenuItem value="60M">1 Hour</MenuItem>
        </TextField>
      </Grid>

      {/* Switches */}
      <Grid item xs={4}>
        <FormControlLabel
          control={<Switch checked={formData.approval_required} onChange={handleChange} name="approval_required" />}
          label="Approval Required"
        />
      </Grid>
      <Grid item xs={4}>
        <FormControlLabel
          control={<Switch checked={formData.carry_forward_allowed} onChange={handleChange} name="carry_forward_allowed" />}
          label="Carry Forward Allowed"
        />
      </Grid>
      <Grid item xs={4}>
        <FormControlLabel
          control={<Switch checked={formData.is_active} onChange={handleChange} name="is_active" />}
          label="Active"
        />
      </Grid>

      {/* Action Buttons */}
      {/* <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={handleSave} sx={{ mr: 2 }}>
          {isEdit ? "Update" : "Save"}
        </Button>
        {isEdit && (
          <Button variant="contained" color="error" onClick={handleDelete} sx={{ mr: 2 }}>
            Delete
          </Button>
        )}
        <Button variant="outlined" onClick={onClose}>
          Exit
        </Button>
      </Grid> */}
    </Grid>
  );
};

export default AddUpdateOT;
